import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {PutFiveStars, PutFiveStarsModel, PutFiveStarsParams} from 'domain/usecases';

export class RemotePutFiveStars implements PutFiveStars {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<PutFiveStarsModel>,
	) {}

	async put(params: PutFiveStarsParams): Promise<PutFiveStarsModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'put',
			body: params,
		});
		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
